import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Redirect} from 'react-router-dom'
import StoreSummary from './index'

const StoreSummaryRegistration = (props) => {
    return (props.registration.pending ? <StoreSummary {...this.props} /> : <StoreSummary {...this.props} />)
};

const mapStateToProps = (state) => {
  return {
    registration: state.registration,
  };
};

export default connect(mapStateToProps)(StoreSummaryRegistration);



// WEBPACK FOOTER //
// ./src/components/store-summary/index-registration.jsx